import { RNHNivelGet } from "services/services-mia/programa-salud/estructuras/RNHNivelGet";


export const nombresDeNivelPorCod = async (credentials) => {
    const { data } = await RNHNivelGet(credentials);

    return Object.fromEntries(
        (data ?? [])
            .filter((nivel) => nivel?.rnhNivelCod)
            .map((nivel) => [nivel.rnhNivelCod, nivel.rnhNivelNombre])
    );
};
